import React, { useContext, useState } from 'react';
import { Ribbon } from './CategoryWidget.styles';
import { Breadcrumbs } from 'BudgetTracker/BudgetPerformance/BudgetPerformance.styles';
import { ButtonWrapper } from 'TempLabour/styles';
import { ApButtonSecondary } from '@alixpartners/ui-components';
import { useChartContext } from 'contexts/CategoryChartContext';
import { useFilterContext } from 'contexts/FilterContext';
import LoadingIndicator from 'components/LoadingIndicator';
import withCategoryWidgetsProviders from 'CategoryManagement/HOCs/withCategoryWidgetsProviders';
import { UploadCategoryStateContext } from 'contexts/UploadCategoryStateContext';
import AppendCategoryData from 'CategoryManagement/AppendCategoryData/AppendCategoryData';
import ChartsWrapper from './TempLabor/ChartWrapper';
const DEFAULTCHARTTYPE = ['bls', 'client'];
export const chartsOptionInitial = [
	{
		key: 0,
		name: 'Scatter plot',
		title: 'BLS - Wage Median Growth',
		show: true,
		chartType: 'bls',
	},
	{
		key: 6,
		name: 'Pie Chart',
		title: 'Total Spend Breakdown',
		show: true,
		chartType: 'client',
	},
	{
		key: 7,
		name: 'Pie Chart',
		title: 'Spend by Paycode',
		show: true,
		chartType: 'client',
	},
	{
		key: 8,
		name: 'Heat Map',
		title: 'Spend By State',
		show: true,
		chartType: 'client',
	},
	{
		key: 9,
		name: 'Spline Column Chart',
		title: 'W.Avg Margin & Gross Spend by Suppliers',
		show: true,
		chartType: 'client',
	},
	{
		key: 10,
		name: 'Spline Column Chart',
		title: 'W.Avg Margin & Gross Spend By Group',
		show: true,
		chartType: 'client',
	},
	{
		key: 11,
		name: 'Spline Column Chart',
		title: 'W.Avg Margin and Gross Spend By Job Title',
		show: true,
		chartType: 'client',
	},
	{
		key: 1,
		name: 'Stacked BarChart',
		title: 'Mark Up Compression',
		show: true,
		chartType: 'client',
	},
	{
		key: 2,
		name: 'Box Plot(client)',
		title: 'Bill Rate Range',
		xLabel: 'Job Title',
		yLabel: 'Bill Rate',
		client: true,
		show: true,
		boxplotSeriesName: 'Bill Rate (Quartile Values)',
		scatterPlotSeriesName: 'Bill Rate (Absolute Values)',
		chartType: 'client',
	},
	{
		key: 3,
		name: 'BLS City',
		title: 'BLS Hourly wage distribution by City',
		show: true,
		chartType: 'bls',
	},
	{
		key: 4,
		name: 'BLS MSA',
		title: 'BLS Hourly wage distribution by State',
		show: true,
		chartType: 'bls',
	},
	{
		key: 5,
		name: 'Box Plot',
		title: 'BLS - Hourly Wage Median',
		xLabel: 'State',
		yLabel: 'Average of Hourly Wage Median',
		client: false,
		show: true,
		boxplotSeriesName: 'Average of Hourly Wage Median (Quartile Values)',
		scatterPlotSeriesName: 'Average of Hourly Wage Median (Absolute Values)',
		chartType: 'bls',
	},
];

const DashBoard = ({ setCurrentContent, currentTab }) => {
	const chartsOption = chartsOptionInitial;
	const { state } = useChartContext();
	const { state: newState } = useFilterContext();
	const [showUpload, setShowUpload] = useState(false);
	const { categoryStatus } = useContext(UploadCategoryStateContext);
	return (
		<div style={{ width: '100%', overflow: 'scroll' }}>
			{state.loading || newState.loading ? (
				<LoadingIndicator loading />
			) : (
				<>
					<Ribbon>
						<Breadcrumbs>
							<span onClick={() => setCurrentContent(0)}>TempLabor</span>&nbsp;/&nbsp;<span
							>
								{showUpload ? 'Upload Data' : 'Dashboard'}
							</span>
						</Breadcrumbs>
						{DEFAULTCHARTTYPE[currentTab] === 'client' && (
							<div style={{ display: 'flex' }}>
								<ButtonWrapper>
									<ApButtonSecondary
										onClick={() => setShowUpload(true)}
										iconName="cloud_upload"
										small
									>
										Upload data
									</ApButtonSecondary>
								</ButtonWrapper>
							</div>
						)}
					</Ribbon>
					{DEFAULTCHARTTYPE[currentTab] === 'client' &&
					(showUpload ||
						categoryStatus.state > 1 ||
						categoryStatus.rowCount === 0) ? (
						<AppendCategoryData setCurrentContent={setCurrentContent} />
					) : (
						<ChartsWrapper
							chartsOption={chartsOption.filter(
								data => data.chartType === DEFAULTCHARTTYPE[currentTab]
							)}
							currentTab={currentTab}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default withCategoryWidgetsProviders(DashBoard);
